<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogVisible"
    width="860px"
    :close-on-click-modal="false"
    @closed="reset"
  >
    <app-form
      v-if="mode !== 'batch' && dialogVisible"
      :form-data="formConfig"
      @confirm="onFormConfirm"
      @cancel="close"
    />

    <el-form v-else-if="dialogVisible" ref="batchForm" :model="batchForm" size="mini" label-width="90px">
      <el-form-item label="游戏" required>
        <select-tree
          :value="batchForm.parent_game_id"
          :options="gameOptions"
          :ischeckbox="false"
          :props="treeProps"
          :select-props="treeSelectProps"
          @getValue="batchForm.parent_game_id = $event"
        />
      </el-form-item>
      <el-form-item label="标签等级" required>
        <el-select v-model="batchForm.level" placeholder="请选择标签等级" clearable>
          <el-option v-for="item in levelOptions" :key="item.value" :label="item.label" :value="item.value" />
        </el-select>
      </el-form-item>
      <el-form-item label="CSV 文件" required>
        <el-upload
          action="#"
          accept=".csv,text/csv"
          :auto-upload="false"
          :show-file-list="false"
          :before-upload="beforeUpload"
          :on-change="onFileChange"
        >
          <el-button size="mini" icon="el-icon-upload2">选择 CSV 文件</el-button>
        </el-upload>
        <div class="upload-tip">
          <span>请先下载 CSV 模板，填写标签和标签说明后再上传，最多 20 条</span>
          <a class="template-link" href="/file/material-label-template.csv" download="material-label-template.csv">下载 CSV 模板</a>
        </div>
      </el-form-item>
      <el-table v-if="previewRows.length" class="batch-label-table" :data="previewRows" border size="mini" max-height="360px">
        <el-table-column type="index" label="#" width="55" />
        <el-table-column label="标签" min-width="180">
          <template slot-scope="scope">
            <el-input v-model="scope.row.label" size="mini" maxlength="10" show-word-limit />
          </template>
        </el-table-column>
        <el-table-column label="标签说明" min-width="360">
          <template slot-scope="scope">
            <el-input
              v-model="scope.row.remark"
              type="textarea"
              :autosize="{ minRows: 1, maxRows: 3 }"
              resize="vertical"
              size="mini"
            />
          </template>
        </el-table-column>
        <el-table-column label="校验提示" min-width="180">
          <template slot-scope="scope">
            <span v-if="rowError(scope.row)" class="error-text">{{ rowError(scope.row) }}</span>
            <span v-else class="success-text">有效</span>
          </template>
        </el-table-column>
      </el-table>
      <div class="form-control">
        <el-button @click="close">取消</el-button>
        <el-button type="primary" :disabled="!canSubmitBatch" @click="onBatchConfirm">确定</el-button>
      </div>
    </el-form>
  </el-dialog>
</template>

<script>
import { decodeMaterialLabelCsv, parseMaterialLabelCsv } from '../model/csv';
const formConfigFactory = require('../model/form-config.js');

export default {
  name: 'MaterialLabelDialog',
  components: {
    'app-form': () => import('@/components/app-form'),
    'select-tree': () => import('@/components/select-tree'),
  },
  props: {
    visible: Boolean,
    mode: {
      type: String,
      default: 'add',
    },
    row: {
      type: Object,
      default: null,
    },
    gameOptions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      dialogVisible: false,
      formConfig: {},
      batchForm: {
        parent_game_id: null,
        level: '',
      },
      previewRows: [],
      fileErrors: [],
      levelOptions: [
        { label: '一级标签', value: 1 },
        { label: '二级标签', value: 2 },
      ],
      treeProps: { value: 'id', label: 'name', children: 'children' },
      treeSelectProps: {
        placeholder: '请选择游戏',
        size: 'mini',
        clearable: true,
        accordion: true,
      },
    };
  },
  computed: {
    title() {
      return this.mode === 'edit' ? '编辑标签' : this.mode === 'batch' ? '批量新增标签' : '新增标签';
    },
    canSubmitBatch() {
      return Boolean(
        this.batchForm.parent_game_id &&
        this.batchForm.level &&
        this.previewRows.length &&
        !this.fileErrors.length &&
        this.previewRows.every(row => !this.rowError(row))
      );
    },
  },
  watch: {
    visible(value) {
      this.dialogVisible = value;
      if (value) {
        this.initialize();
      }
    },
    dialogVisible(value) {
      if (value !== this.visible) {
        this.$emit('update:visible', value);
      }
    },
    gameOptions(value) {
      if (this.formConfig.parent_game_id) {
        this.formConfig.parent_game_id.props.options = value;
      }
    },
  },
  methods: {
    initialize() {
      this.previewRows = [];
      this.fileErrors = [];
      this.batchForm = { parent_game_id: null, level: '' };
      if (this.mode === 'batch') {
        return;
      }
      this.formConfig = this.mode === 'edit' ? formConfigFactory.createEditFormConfig() : formConfigFactory.createAddFormConfig();
      if (this.formConfig.parent_game_id) {
        this.formConfig.parent_game_id.props.options = this.gameOptions;
      }
      if (this.mode === 'edit' && this.row) {
        this.formConfig.label.value = this.row.label || '';
        this.formConfig.remark.value = this.row.remark || '';
        this.formConfig.level.value = this.row.level || '';
      }
    },
    onFormConfirm(params) {
      if (this.mode === 'edit') {
        this.$emit('confirm', { id: this.row.id, data: params });
        return;
      }
      this.$emit('confirm', {
        parent_game_id: params.parent_game_id,
        level: params.level,
        labels: [{ label: params.label, remark: params.remark }],
      });
    },
    beforeUpload() {
      return false;
    },
    onFileChange(file) {
      if (!file || !file.raw) {
        return;
      }
      const reader = new FileReader();
      reader.onload = (event) => {
        const result = parseMaterialLabelCsv(decodeMaterialLabelCsv(event.target.result));
        const countError = result.errors.find(error => !error.row && error.message.includes('最多支持20条'));
        if (countError) {
          this.previewRows = [];
          this.fileErrors = [countError];
          this.$message.error(countError.message);
          return;
        }
        this.previewRows = result.rows;
        this.fileErrors = result.errors.filter(error => ![
          '标签不能为空',
          '标签最大长度限制10个字',
          '标签说明不能为空',
        ].includes(error.message));
        if (this.fileErrors.length) {
          this.$message.error(this.fileErrors.map(error => error.message).join('；'));
        }
      };
      reader.onerror = () => {
        this.previewRows = [];
        this.fileErrors = [{ row: 1, message: 'CSV 文件读取失败' }];
        this.$message.error('CSV 文件读取失败');
      };
      reader.readAsArrayBuffer(file.raw);
    },
    rowError(row) {
      if (!row.label || !String(row.label).trim()) {
        return '标签不能为空';
      }
      if (row.label.length > 10) {
        return '标签最大长度限制10个字';
      }
      if (!row.remark || !String(row.remark).trim()) {
        return '标签说明不能为空';
      }
      return '';
    },
    onBatchConfirm() {
      if (!this.canSubmitBatch) {
        return;
      }
      this.$emit('confirm', {
        parent_game_id: this.batchForm.parent_game_id,
        level: this.batchForm.level,
        labels: this.previewRows.map(({ label, remark }) => ({ label, remark })),
      });
    },
    close() {
      this.dialogVisible = false;
      this.$emit('cancel');
    },
    reset() {
      this.previewRows = [];
      this.fileErrors = [];
    },
  },
};
</script>

<style lang="scss" scoped>
.upload-tip {
  color: #909399;
  font-size: 12px;
  line-height: 22px;
}
.template-link {
  margin-left: 10px;
  color: #409eff;
}
.error-text { color: #f56c6c; }
.success-text { color: #67c23a; }
.form-control { margin-top: 20px; text-align: right; }
.batch-label-table .el-textarea__inner { line-height: 1.5; }
</style>
